import React from "react";
import Login from "../Login/Login";
import "./Auth.css";

export default function Auth({ setUser }) {
  return (
    <div className="AuthContainer">
      <div className="bgLogin"></div>
      <Login setUser={setUser} />
    </div>
  );
}
